import DatetimeColumn, { cellType, datetimeColumnConfiguration } from './DatetimeColumn.component';

export { cellType, DatetimeColumn };
export default datetimeColumnConfiguration;
